import React from 'react';
import Banner from './Banner';
import Section2 from './Section2';
import Services from './Services';
import Specialist from './Specialist';

const Home = () => {
    return (
        <div>
            <Banner />
            <Section2 />
            <Services />
            <Specialist />
        </div>
    );
};

export default Home;